module.exports = __webpack_public_path__ + "static/media/graph-database-intro.833b1de5.jpg";